import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import brain from '@/assets/images/brain-doesnt-know.png';
import heart from '@/assets/images/heart-muscles.png';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { mergeClasses } from '@/utils/style';
import BrainPointingImage from '@/assets/images/brain-pointing-right.png';
import HeartPointingImage from '@/assets/images/heart-pointing-left.png';
export function DiscoverRewards(t0) {
  const $ = _c(26);
  const {
    className
  } = t0;
  const {
    t
  } = useTranslation("discounts");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="4xl:w-auto absolute top-14 left-0 hidden w-80 lg:block"><Image src={HeartPointingImage} width={416} height={320} alt="" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="4xl:w-auto absolute top-14 right-0 hidden w-80 lg:block"><Image src={BrainPointingImage} width={370} height={320} alt="" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = mergeClasses("flex flex-row flex-wrap items-center justify-center md:flex-nowrap", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("eshop.discoverRewards.title");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <SectionHeadline className="mb-4 whitespace-nowrap lg:mb-6" anchorKey="eshop.discoverRewards.title">{t4}</SectionHeadline>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("eshop.discoverRewards.text");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <p className="mb-10 px-4 text-center text-sm lg:mb-12 lg:px-0 lg:text-base">{t6}</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = LINKS();
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = t8.rewards;
  let t10;
  if ($[13] !== t) {
    t10 = t("eshop.discoverRewards.cta");
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <Button variant="primary" testId="discoverRewards" analyticsParam="discoverRewards" to={t9} size="lg" align="center" className="mb-10 lg:mb-0">{t10}</Button>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t5 || $[19] !== t7) {
    t12 = <div className="md:order-2 md:w-1/2 lg:w-full lg:max-w-148">{t5}{t7}{t11}</div>;
    $[17] = t11;
    $[18] = t5;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="w-1/2 pl-4 md:order-1 md:p-4 lg:hidden"><Image src={brain} alt="" width={384} /></div>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="w-1/2 pr-4 md:order-3 md:p-4 lg:hidden"><Image src={heart} alt="" width={360} /></div>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t12 || $[24] !== t3) {
    t15 = <div className="relative bg-blue-50 pt-20 pb-8 lg:pb-28">{t1}{t2}<ContentContainer><div className={t3}>{t12}{t13}{t14}</div></ContentContainer></div>;
    $[23] = t12;
    $[24] = t3;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
}